// src/components/ClaimDetail/ClaimDataPanel.jsx
//
// Pestaña "Datos" del reclamo: el enlace al CRM, la depreciación recuperable
// (si el reclamo la tiene) y la información extendida.
// Los accesos rápidos (llamar, mapa, correo) y el resumen de datos clave viven
// ahora en la cabecera de la ficha (ClaimHeader / ClaimContact.jsx), junto al
// nombre del cliente.
import React from 'react';
import ClaimExtendedInfo from '../Dashboard/ClaimExtendedInfo';
import RecoverableDepreciationCard from './RecoverableDepreciationCard';
import './ClaimDetail.css';

// claimRecord: el padre tal cual, para la información extendida (null mientras carga).
const ClaimDataPanel = ({ claimRecord, crmLink, language }) => {
  const es = language === 'es';
  return (
    <div className="claim-data">
      {crmLink && (
        <a href={crmLink} target="_blank" rel="noopener noreferrer" className="claim-data-crm">
          {es ? 'Abrir en CRM' : 'Open in CRM'} <i className="fa-solid fa-arrow-up-right-from-square" aria-hidden="true"></i>
        </a>
      )}
      {claimRecord && <RecoverableDepreciationCard claimRecord={claimRecord} language={language} />}
      <ClaimExtendedInfo claimRecord={claimRecord} defaultOpen />
    </div>
  );
};

export default ClaimDataPanel;
